const doc = [({"en":({"js":({"merfoto":({"order_deliveries":({"delivery_methods":({"shipmondo":({"index":({"zip_code":"Zip code"})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;